export const CORE_AUTH_ENDPOINTS = {
  register: 'accounts/register',
  login: 'accounts/login',
  logout: 'accounts/logout',
  refreshToken: 'accounts/refresh-token',
  changePhoneNumber: 'accounts/phone-number',
  forgetPassword: 'accounts/forget-password',
} as const;
